import { IconName } from 'components_new/atoms/Icon'
import { ShowPerEnum } from 'types/GlobalMetric'

export enum Condition {
  IS_NULL = 'IS NULL',
  EQ = '=',
  NE = '!=',
  LTE = '<=',
  LT = '<',
  GTE = '>=',
  GT = '>',
  IS_NOT_NULL = 'IS NOT NULL'
}

export enum ComparativeDisplayType {
  PERCENTAGE = 'PERCENTAGE',
  PERCENTAGE_AND_VALUE = 'PERCENTAGE_AND_VALUE',
  VALUE = 'VALUE',
  PREVIOUS_VALUE = 'PREVIOUS_VALUE',
  HIDDEN = 'HIDDEN'
}

export enum FilterType {
  ONLY_LEFT = 'ONLY_LEFT',
  INPUT_VALUE = 'INPUT_VALUE',
  FROM_TO = 'FROM_TO',
  NUMBER = 'NUMBER'
}

export interface FilterPatchBody {
  attribute_option_id: string
  condition: Condition
  filter_group_id?: string | null
  value: number | string | null
  type: FilterType
  from_value?: string
  to_value?: string
}

export interface FilterConditionFormatBody {
  filter_group_id?: string | null
  attribute_option: {
    selected: string | null
  }
  condition: {
    selected: Condition | null
    options: Condition[]
  }
  type: {
    selected: FilterType | null
    options: FilterType[]
  }
  value: {
    selected: number | (string | null)[] | null
  }
  from_value?: {
    selected: string | null
  }
  to_value?: {
    selected: string | null
  }
}

export enum UnitPrefix {
  THOUSAND = 'THOUSAND',
  MILLION = 'MILLION',
  BILLION = 'BILLION'
}

export enum RollingType {
  R7 = 'R7',
  R30 = 'R30',
  R90 = 'R90',
  R365 = 'R365',
  R12 = 'R12'
}

export const translateShowPerEnum: Record<
  ShowPerEnum,
  {
    iconName: IconName
  }
> = {
  [ShowPerEnum.RENTABLE_SQM]: {
    iconName: 'CropFreeOutlined'
  },
  [ShowPerEnum.ATEMP]: {
    iconName: 'HvacOutlined'
  },
  [ShowPerEnum.BTA]: {
    iconName: 'HouseSidingOutlined'
  },
  [ShowPerEnum.NUMBER_OF_OBJECTS]: {
    iconName: 'ViewInArOutlined'
  },
  [ShowPerEnum.NUMBER_OF_DWELLINGS]: {
    iconName: 'LivingOutlined'
  },
  [ShowPerEnum.NUMBER_OF_SPACES]: {
    iconName: 'BedroomChildOutlined'
  },
  [ShowPerEnum.NUMBER_OF_UNITS]: {
    iconName: 'LocalLaundryServiceOutlined'
  },
  [ShowPerEnum.RENTED_SQM]: {
    iconName: 'CheckBoxOutlined'
  },
  [ShowPerEnum.NUMBER_OF_DAYS]: {
    iconName: 'CalendarMonthOutlined'
  },
  [ShowPerEnum.NUMBER_OF_WORKDAYS]: {
    iconName: 'DateRangeOutlined'
  },
  [ShowPerEnum.NUMBER_OF_MOVE_INS]: {
    iconName: 'DoorBackOutlined'
  },
  [ShowPerEnum.NUMBER_OF_SNOW_DAYS]: {
    iconName: 'PerSnowDay'
  }
}

export interface KpiOptionObject {
  auto_format: boolean
  breakdown_by: {
    selected: string | null
  }
  can_show_details: boolean
  comparative_display_type: {
    selected: ComparativeDisplayType | null
    options: ComparativeDisplayType[]
  }
  entity_id: string | null
  equivalent: {
    factor: number | null
    unit: string | null
  }
  fact_table_id: string
  filters: FilterConditionFormatBody[]
  share_filters: FilterConditionFormatBody[]
  show_per_filters: FilterConditionFormatBody[]
  required_target_missing: boolean
  id: string
  index: number
  upper_bound_threshold: number | null
  lower_bound_threshold: number | null
  hidden: boolean
  increase_is_positive: boolean
  is_share_kpi: boolean
  number_of_decimals: number
  kpi_template_id: string
  variant_kpi_template_id: string | null
  distribution: ShowPerEnum | null
  rolling_sum: RollingType | null
  slices: string[]
  title: string
  original_unit: string | null
  unit: string | null
  unit_prefix: {
    selected: UnitPrefix | null
    options: { value: UnitPrefix; label: string }[]
  }
  widget_id: string
}

export type KpiOptionReduxResponse = {
  option: KpiOptionObject
  dashboardId: string
  skipFetchData?: boolean
}

export type KpiOptionPatchResponse = {
  data: KpiOptionObject[]
  dashboardId: string
  skipFetchData?: boolean
}
